// extracted by mini-css-extract-plugin
export default {"link":"XN-z","disabled":"YN-z"};